<template>

  <v-data-table
    :headers="headers"
    :items="disciplinas"

    :sort-desc="true"

    class="elevation-1"
    :search="search"
  >

    <template v-slot:top>
      <v-toolbar flat color="white">
         <v-progress-circular
                        :size="50"
                        color="green"
                        indeterminate
                         v-if="isLoading"
                      ></v-progress-circular>
        <v-btn
          @click="$router.push('selecionar-turmas')"
          class="mx-2"
          fab
          dark
          color="primary"
        >
          <v-icon dark>arrow_back</v-icon>
        </v-btn>

        <v-divider class="mx-8" inset vertical></v-divider>
        <v-toolbar-title>
          Turma(s) da
          <span v-if="idclasse === 1">10ª classe</span>
          <span v-if="idclasse === 2">11ª classe</span>
          <span v-if="idclasse === 3">12ª classe</span>
          <span v-if="idclasse === 4">13ª classe</span>
        </v-toolbar-title>
        <v-divider class="mx-8" inset vertical></v-divider>
             <span>Selecionado : <strong style="font-size:22px;">{{$store.state.novadescricaoSelecionado}}</strong></span>
        <!--  search  -->
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>

        <div class="flex-grow-1"></div>

        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <!-- end  search  -->

        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">

          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }} -</span>
              <span v-if="idclasse === 1">10ª classe</span>
              <span v-if="idclasse === 2">11ª classe</span>
              <span v-if="idclasse === 3">12ª classe</span>
              <span v-if="idclasse === 4">13ª classe</span>
            </v-card-title>

          </v-card>
        </v-dialog>
         <div>
    <v-row justify="center">
    <v-dialog v-model="trimestreDialog" persistent max-width="390">
      <v-card>
        <v-overlay :value="progress">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
        <v-card-title class="headline">Selecione o Trimestre desejado</v-card-title>
         <v-col
            cols="12"
            md="12"
          >
            <v-select
              v-model="trimestre"
              item-value="idTrimestre"
              item-text="descricao"
              :items="trimestres"
              :disabled="isUpdating"
               filled
              color="blue-grey lighten-2"
              label="Trimestre"
              return-object
            ></v-select>
          </v-col>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="trimestreDialog=false">Cancelar</v-btn>
           <v-btn color="green darken-1" text @click="comporMiniPauta(miniPauta)">Concordar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </div>

  <div>
    <v-row justify="center">
    <v-dialog v-model="trimestreDialogAVC" persistent max-width="390">
      <v-card>
        <v-overlay :value="progress">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
        <v-card-title class="headline">Selecione o Trimestre desejado</v-card-title>
         <v-col
            cols="12"
            md="12"
          >
            <v-select
              v-model="trimestre"
              item-value="idTrimestre"
              item-text="descricao"
              :items="trimestresAv"
              :disabled="isUpdating"
               filled
              color="blue-grey lighten-2"
              label="Trimestre"
              return-object
            ></v-select>
          </v-col>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="trimestreDialogAVC=false">Cancelar</v-btn>
           <v-btn color="green darken-1" text @click="miniPauta_($store.state.objturma)">Concordar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </div>

      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn small fab color="#006699" @click=" escolherOTrimestre(item) "
                              v-bind="attrs"
                              v-on="on"
                            >
                            <v-icon  style="color:palegoldenrod">print</v-icon>
                              </v-btn>
                          </template>
                          <span>Mini pauta.</span>
                      </v-tooltip>
                     <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn small fab color="#006699" @click="$store.state.objturma = item; trimestreDialogAVC = true;"
                              v-bind="attrs"
                              v-on="on"
                            >
                            <v-icon  style="color:orange">print</v-icon>
                              </v-btn>
                          </template>
                          <span>Mapa de controlo das avaliações contínuas.</span>
                      </v-tooltip>

    </template>
    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>

</template>
<script>
import axios from '../../../../../plugins/axios'
const ls = require('local-storage')
const help = require('../../../../../../Helpers/Helpers')
export default {
  data: () => ({
    trimestreDialogAVC: false,
    insignia: (ls.get('i_id') === 24 ? ls.get('logotipo') : ls.get('insignia')),
    configuracoesReport: [],
    url: '',
    option: { 'format': 'A3',
      'orientation': 'landscape',
      paginationOffset: 2,
      'header': {
        'height': '10mm',
        'contents': '<div style="text-align: center;"></div>' },
      'footer': {
        'height': '5mm'
      } },
    progress: false,
    objTurma: {},
    backTo: null,
    trimestreDialog: false,
    isUpdating: false,
    overlay: false,
    trimestre: 0,
    trimestres: [{
      idTrimestre: 1,
      descricao: '1º Trimestre',
      withNota: true
    },
    {
      idTrimestre: 2,
      descricao: '2º Trimestre',
      withNota: true
    },
    {
      idTrimestre: 3,
      descricao: '3º Trimestre',
      withNota: true
    }
    ],
    trimestresAv: [{
      idTrimestre: 1,
      descricao: '1º Trimestre',
      withNota: true
    },
    {
      idTrimestre: 2,
      descricao: '2º Trimestre',
      withNota: true
    },
    {
      idTrimestre: 3,
      descricao: '3º Trimestre',
      withNota: true
    }
    ],
    text: '',
    flag_curso: '',
    formValid: true,
    alunosTurma: [],
    flag_periodo: '',
    flag_sala: '',
    flag_class: '',
    sala: '',
    search: '',
    quant: 0,
    cursos: [],
    html: ``,
    notas: [],
    isLoading: false,
    disciplinas: [],
    miniPauta: [],
    dialog: false,
    headers: [
      {
        text: 'Disciplinas',
        align: 'left',
        sortable: false,
        value: 'descricao'
      },
      { text: 'Acção', value: 'action', sortable: false }
    ]

  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nova Turma' : 'Editar Turma'
    },

    idclasse () {
      return this.$store.state.idclasse
    },
    classeTur () {
      return this.$store.state.classeTur
    }
  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.backTo = ls.get('backTo')
    this.disciplinasTurmaAll()
    this.carregarConfiguracoesReports()
    if (ls.get('i_id') === 24) {
      this.trimestres.push({
        idTrimestre: 4,
        descricao: 'Todos',
        withNota: true
      })
    }
  },

  methods: {

    async disciplinasTurmaAll () {
      try {
        this.isLoading = true
        this.disciplinas = await axios
          .get('/disciplinaTurma/' + ls.get('disciplinasDaTurma').idCurso + '/' + ls.get('disciplinasDaTurma').idclasse)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    escolherOTrimestre (disciplinaobj) {
      this.objTurma = disciplinaobj
      this.trimestreDialog = true
      if (this.$store.state.minipauta.length > 0 && this.$store.state.minipauta.filter(t => t.iddisciplina === this.objTurma.iddisciplina).length) {
        this.miniPauta = this.$store.state.minipauta.filter(t => t.iddisciplina === this.objTurma.iddisciplina)[0].notas
        this.progress = false
      } else {
        this.miniPauta_(disciplinaobj)
      }
    },

    mapaAvc (item) {
      ls.set('disciplinaobj', { trimestre: this.trimestre, classe: item.classe, descricao: item.descricao, iddisciplina: item.iddisciplina })
      ls.set('backTo', 'turmacrud24')
      this.$router.push('mapacontroloAv24')
    },
    async miniPauta_ (item) {
      this.objTurma = item
      let value = {
        idDsciplina: this.objTurma.iddisciplina,
        pkTurma: ls.get('disciplinasDaTurma').pkTurma,
        anoLectivo: ls.get('disciplinasDaTurma').anoLectivo
      }
      try {
        this.progress = true
        this.miniPauta = await axios
          .post('/miniPauta', value)
          .then(res => res.data)
        this.$store.state.minipauta.push({ iddisciplina: this.objTurma.iddisciplina, notas: this.miniPauta[0] })
        this.miniPauta = this.miniPauta[0]
        if (this.trimestreDialogAVC) {
          this.mapaAvc(item)
        }
        this.progress = false
      } catch (error) {
        this.progress = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    zebraPauta (i) {
      if (i % 2) {
        return 'zebr'
      } else {
        return ''
      }
    },
    isNull (nota) {
      if (nota) { return nota } else return ''
    },
    comporMiniPauta (dados) {
      let miniPautaConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'pauta')
      let options = { 'format': 'A4',
        'border': {
          'top': '10mm', // default is 0, units: mm, cm, in, px
          'right': '5mm',
          'bottom': '10mm',
          'left': '5mm'
        } }
      let dadosBoletim = ''
      let i = 0
      if (this.trimestre.idTrimestre === 1) {
        dados.forEach(element => {
          dadosBoletim += `<tr class="notas ` + this.zebraPauta(i) + `">
                    <td style="text-align:justify;">   ` + element.nome + `</td>
                    <td>   ` + this.isNull(element.t1_mac) + `</td>
                    <td> ` + this.isNull(element.t1_nota1) + `</td>
                    <td>  ` + this.isNull(element.t1_nota2) + ` </td>
                    <td>  ` + this.isNull(element.t1_md) + ` </td>
                </tr>`
          i++
        })

        this.html = `<html>
<head>
    <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
    <style>
    body { font-family: Arial, Helvetica, sans-serif;}
.invoice-box {
max-width: 800px;
margin: auto;
padding: 10px;
padding-top: 0px;
border: 0px solid #eee;
box-shadow: 0 0 10px rgba(0, 0, 0, .15);
line-height: 14px;
color: #555;
font-family: Arial, Helvetica, sans-serif;
}
.invoice-box table {
width: 100%;
line-height: inherit;
text-align: center;
}
.invoice-box table tr.heading td {
background: #eee;
border: 1px solid #ddd;
font-weight: bold;
padding-top:10px;
}
.invoice-box table tr.titulo td {
font-size:10px;
text-align:justify;
}
.invoice-box table tr.notas td {
font-size:9px;
text-align:center;
border: 1px solid #ddd;
padding-top:5px;
}
table, th { font-size: 10px; }
.zebr{ background-color: #eee; }
.removeborder{ border:0px; }
.cabecalho{ font-size: 12px;font-weight:bold;text-align:center; }
    </style>
</head>
<body>
    <div class="invoice-box">
      <table class="removeborder">
                    <tr class="removeborder">
                    <td class="removeborder" width="25%"> </td>
                  <td width="50%" class="removeborder cabecalho">
                  <img src="` + this.insignia + `" alt="" style="width:50px;height:30px;display: block;margin-left: auto;margin-right: auto;">
                    </td>
                    <td width="25%" class="removeborder"></td>
                   </tr>

                   <tr class="removeborder">
                    <td class="removeborder" width="25%"> </td>
                  <td width="50%" class="removeborder cabecalho">
                    REPÚBLICA DE ANGOLA <br>
                  MINISTÉRIO DA EDUCAÇÃO<br>
                  ` + ls.get('instituicaodescricao').toUpperCase() + ` <br>
                    MINI PAUTA  </td>
                    <td width="25%" class="removeborder"></td>
                   </tr>                   
                  </table>  <br> 

                  <table>
                            <tr class="titulo">
                            <td width="50%">                                    
                            Disciplina: ` + this.objTurma.descricao + `<br>
                            Ano lectivo: ` + this.$store.state.novadescricaoSelecionado + `<br>
                            Curso: ` + ls.get('disciplinasDaTurma').curso + `                               
                            </td>
                           <td width="50%">
                              Turma: ` + ls.get('disciplinasDaTurma').turma + ` <br>
                              Periodo: ` + ls.get('disciplinasDaTurma').periodo + `<br>
                              Classe: ` + this.objTurma.classe + `
                            </td>
                            </tr>
                        </table>

                        <table cellpadding="0" cellspacing="0">
                  
                <tr class="heading">
                    <td rowspan="2">
                   Nome
                    </td>
                    <td colspan="4">
                      ` + this.trimestre.descricao + ` 
                    </td>                   
                </tr>

                <tr class="heading">
                    <td>  Mac  </td>
                    <td>  P1  </td>
                    <td>  P2  </td>
                    <td> MT </td>      
                </tr>
                 
        ` + dadosBoletim + `
        </table>
        <br>
        <table class="removeborder">
             <tr class="removeborder">
              <td class="removeborder">Luanda, ` + help.presente_data() + ` </td>
              </tr>
              </table><br>
         <table class="removeborder">
             <tr class="removeborder">
                 <td width="50%" class="removeborder">` + (miniPautaConfiguracoes[1].valor) + `</td>
                 <td width="50%" class="removeborder">` + (miniPautaConfiguracoes[2].valor) + `</td>
             </tr>
             <tr class="removeborder">
                 <td class="removeborder">_____________________________</td>
                 <td class="removeborder">_____________________________</td>
            </tr>
         </table>
        </div>
    </body>
</html>
`
        this.MiniPautagerarpdf(options)
      } else
      if (this.trimestre.idTrimestre === 2) {
        dados.forEach(element => {
          dadosBoletim += `<tr class="notas ` + this.zebraPauta(i) + `">
                    <td style="text-align:justify;">   ` + element.nome + `</td>
                    <td>   ` + this.isNull(element.t2_mac) + `</td>
                    <td> ` + this.isNull(element.t2_nota1) + `</td>
                    <td>  ` + this.isNull(element.t2_nota2) + ` </td>
                    <td>  ` + this.isNull(element.t2_md) + ` </td>
                </tr>`
          i++
        })

        this.html = `<html>
<head>
    <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
    <style>
    body { font-family: Arial, Helvetica, sans-serif;}
.invoice-box {
max-width: 800px;
margin: auto;
padding: 10px;
padding-top: 0px;
border: 0px solid #eee;
box-shadow: 0 0 10px rgba(0, 0, 0, .15);
line-height: 14px;
color: #555;
font-family: Arial, Helvetica, sans-serif;
}
.invoice-box table {
width: 100%;
line-height: inherit;
text-align: center;
}
.invoice-box table tr.heading td {
background: #eee;
border: 1px solid #ddd;
font-weight: bold;
padding-top:10px;
}
.invoice-box table tr.titulo td {
font-size:10px;
text-align:justify;
}
.invoice-box table tr.notas td {
font-size:9px;
text-align:center;
border: 1px solid #ddd;
padding-top:5px;
}
table, th { font-size: 10px; }
.zebr{ background-color: #eee; }
.removeborder{ border:0px; }
.cabecalho{ font-size: 12px;font-weight:bold;text-align:center; }
    </style>
</head>
<body>
    <div class="invoice-box">
      <table class="removeborder">
                    <tr class="removeborder">
                    <td class="removeborder" width="25%"> </td>
                  <td width="50%" class="removeborder cabecalho">
                  <img src="` + this.insignia + `" alt="" style="width:50px;height:30px;display: block;margin-left: auto;margin-right: auto;">
                    </td>
                    <td width="25%" class="removeborder"></td>
                   </tr>

                   <tr class="removeborder">
                    <td class="removeborder" width="25%"> </td>
                  <td width="50%" class="removeborder cabecalho">
                    REPÚBLICA DE ANGOLA <br>
                  MINISTÉRIO DA EDUCAÇÃO<br>
                  ` + ls.get('instituicaodescricao').toUpperCase() + ` <br>
                    MINI PAUTA  </td>
                    <td width="25%" class="removeborder"></td>
                   </tr>                   
                  </table>  <br> 
                 
                  <table>
                            <tr class="titulo">
                            <td width="50%">                                    
                            Disciplina: ` + this.objTurma.descricao + `<br>
                            Ano lectivo: ` + this.$store.state.novadescricaoSelecionado + `<br>
                            Curso: ` + ls.get('disciplinasDaTurma').curso + `                               
                            </td>
                           <td width="50%">
                              Turma: ` + ls.get('disciplinasDaTurma').turma + ` <br>
                              Periodo: ` + ls.get('disciplinasDaTurma').periodo + `<br>
                              Classe: ` + this.objTurma.classe + `
                            </td>
                            </tr>
                        </table>

                        <table cellpadding="0" cellspacing="0">
                  
                <tr class="heading">
                    <td rowspan="2">
                   Nome
                    </td>
                    <td colspan="4">
                      ` + this.trimestre.descricao + ` 
                    </td>                   
                </tr>
                <tr class="heading">
                    <td>  Mac  </td>
                    <td>  P1  </td>
                    <td>  P2  </td>
                    <td> MT </td>      
                </tr>
                  
        ` + dadosBoletim + `
        </table>
        <br>
        <table class="removeborder">
             <tr class="removeborder">
              <td class="removeborder">Luanda, ` + help.presente_data() + ` </td>
              </tr>
              </table><br>
         <table class="removeborder">
             <tr class="removeborder">
                 <td width="50%" class="removeborder">` + (miniPautaConfiguracoes[1].valor) + `</td>
                 <td width="50%" class="removeborder">` + (miniPautaConfiguracoes[2].valor) + `</td>
             </tr>
             <tr class="removeborder">
                 <td class="removeborder">_____________________________</td>
                 <td class="removeborder">_____________________________</td>
            </tr>
         </table>
        </div>
    </body>
</html>
`
        this.MiniPautagerarpdf(options)
      } else
      if (this.trimestre.idTrimestre === 3) {
        dados.forEach(element => {
          dadosBoletim += `<tr class="notas ` + this.zebraPauta(i) + `">
                    <td style="text-align:justify;">   ` + element.nome + `</td>
                    <td>   ` + this.isNull(element.t3_mac) + `</td>
                    <td> ` + this.isNull(element.t3_nota1) + `</td>
                    <td>  ` + this.isNull(element.t3_md) + ` </td>
                </tr>`
          i++
        })

        this.html = `<html>
<head>
    <meta content="text/html; charset=utf-8" http-equiv="Content-Type">
    <style>
    body { font-family: Arial, Helvetica, sans-serif;}
.invoice-box {
max-width: 800px;
margin: auto;
padding: 10px;
padding-top: 0px;
border: 0px solid #eee;
box-shadow: 0 0 10px rgba(0, 0, 0, .15);
line-height: 14px;
color: #555;
font-family: Arial, Helvetica, sans-serif;
}
.invoice-box table {
width: 100%;
line-height: inherit;
text-align: center;
}
.invoice-box table tr.heading td {
background: #eee;
border: 1px solid #ddd;
font-weight: bold;
padding-top:10px;
}
.invoice-box table tr.titulo td {
font-size:10px;
text-align:justify;
}
.invoice-box table tr.notas td {
font-size:9px;
text-align:center;
border: 1px solid #ddd;
padding-top:5px;
}
table, th { font-size: 10px; }
.zebr{ background-color: #eee; }
.removeborder{ border:0px; }
.cabecalho{ font-size: 12px;font-weight:bold;text-align:center; }
    </style>
</head>
<body>
    <div class="invoice-box">
      <table class="removeborder">
                    <tr class="removeborder">
                    <td class="removeborder" width="25%"> </td>
                  <td width="50%" class="removeborder cabecalho">
                  <img src="` + this.insignia + `" alt="" style="width:50px;height:30px;display: block;margin-left: auto;margin-right: auto;">
                    </td>
                    <td width="25%" class="removeborder"></td>
                   </tr>

                   <tr class="removeborder">
                    <td class="removeborder" width="25%"> </td>
                  <td width="50%" class="removeborder cabecalho">
                    REPÚBLICA DE ANGOLA <br>
                  MINISTÉRIO DA EDUCAÇÃO<br>
                  ` + ls.get('instituicaodescricao').toUpperCase() + ` <br>
                    MINI PAUTA  </td>
                    <td width="25%" class="removeborder"></td>
                   </tr>                   
                  </table>  <br> 
                 
                         <table>
                            <tr class="titulo">
                            <td width="50%">                                    
                            Disciplina: ` + this.objTurma.descricao + `<br>
                            Ano lectivo: ` + this.$store.state.novadescricaoSelecionado + `<br>
                            Curso: ` + ls.get('disciplinasDaTurma').curso + `                               
                            </td>
                           <td width="50%">
                              Turma: ` + ls.get('disciplinasDaTurma').turma + ` <br>
                              Periodo: ` + ls.get('disciplinasDaTurma').periodo + `<br>
                              Classe: ` + this.objTurma.classe + `
                            </td>
                            </tr>
                        </table>

     <table cellpadding="0" cellspacing="0">
                  
                <tr class="heading">
                    <td rowspan="2">
                   Nome
                    </td>
                    <td colspan="4">
                      ` + this.trimestre.descricao + ` 
                    </td>                   
                </tr>
                  <tr class="heading">
                    <td>  Mac  </td>
                    <td>  P1  </td>
                    <td> MT </td>      
                </tr>
        ` + dadosBoletim + `
        </table><br>
        <table class="removeborder">
             <tr class="removeborder">
              <td class="removeborder">Luanda, ` + help.presente_data() + ` </td>
              </tr>
              </table><br>
         <table class="removeborder">
             <tr class="removeborder">
                 <td width="50%" class="removeborder">` + (miniPautaConfiguracoes[1].valor) + `</td>
                 <td width="50%" class="removeborder">` + (miniPautaConfiguracoes[2].valor) + `</td>
             </tr>
             <tr class="removeborder">
                 <td class="removeborder">_____________________________</td>
                 <td class="removeborder">_____________________________</td>
            </tr>
         </table>
        </div>
    </body>
</html>
`
        this.MiniPautagerarpdf(options)
      } else
      if (this.trimestre.idTrimestre === 4) {
        this.comporAllTrimestre(dados)
      }
    },
    async comporAllTrimestre (dados) {
      try {
        this.isLoading = true
        let miniPautaConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'pauta')
        this.trimestreDialog = false
        let dadosBoletim = ''
        let cont = 1
        dados.forEach(element => {
          dadosBoletim += `<tr>
                    <td>` + cont + `</td>
                    <td style="text-align:justify;"> ` + element.nome + `</td>
                    <td>` + this.isNull(element.t1_mac) + `</td>
                    <td>` + this.isNull(element.t1_nota1) + `</td>
                    <td>` + this.isNull(element.t1_nota2) + `</td>
                    <td>` + this.isNull(element.t1_md) + `</td>
                    <td></td>

                    
                    <td>` + this.isNull(element.t2_mac) + `</td>
                    <td>` + this.isNull(element.t2_nota1) + `</td>
                    <td>` + this.isNull(element.t2_nota2) + `</td>
                    <td>` + this.isNull(element.t2_md) + ` </td>
                    <td></td>

                   
                    <td>` + this.isNull(element.t3_mac) + `</td>
                    <td>` + this.isNull(element.t3_nota1) + ` </td>
                    <td>` + this.isNull(element.t3_nota2) + `</td>
                    <td> ` + this.isNull(element.t3_md) + `</td>
                    <td></td>

                    <td></td>
                    <td></td>
                    <td></td>
                </tr>`
          cont++
        })

        this.html = `
            <html>
            <head>
            <style>
            body { font-family: Arial, Helvetica, sans-serif;}
            table, td, th {
              border: 1px solid;
              border-width: 1px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
            }
            table, td {
              font-size: 11px;
            }
            table, th {
              text-align:center;
              font-size: 10px;
            }
            .cabecalho{ font-size: 14px; }
            .removeborder{ border:0px; }
            .textjustify{
              text-align:left; 
              border: 1px solid;
            }
      </style>
      </head>
      <body>
 <div style="padding:10px;">
              <table class="removeborder">
                    <tr class="removeborder">
                    <td class="removeborder" width="25%"> </td>
                  <td width="50%" class="removeborder cabecalho">
                  <img src="` + this.insignia + `" alt="" style="width:50px;height:30px;display: block;margin-left: auto;margin-right: auto;"><br>
                  <strong style="font-size:13px"> ` + ls.get('instituicaodescricao').toUpperCase() + ` <br>
                    SUBDIRECÇÃO PEDAGÓGICA<br>
                    MINI PAUTA</strong>
                    </td>
                    <td width="25%" class="removeborder"></td>
                   </tr>
                  </table>  <br>

              <table>
                <tr>
                  <th colspan="10" style="text-align:left;">NOME DO PROFESSOR:</th>
                  <th colspan="6" style="text-align:left;">DISCIPLINA: ` + this.objTurma.descricao + `</th>
                  <th colspan="2">NEG%_______</th>
                  <th colspan="2">POSI%______</th>
                </tr>
                <tr>
                  <th rowspan="2" colspan="10" style="background: orange;">CURSO TÉCNICO DE ` + ls.get('disciplinasDaTurma').curso + `</th>
                  <th rowspan="2" colspan="6">CLASSE: ` + this.objTurma.classe + `</th>
                  <th rowspan="2" colspan="2">SALA:</th>
                  <th colspan="2">ANO LECTIVO ` + this.$store.state.novadescricaoSelecionado + `</th>
                </tr>
                <tr> <th colspan="2">TURNO:  ` + ls.get('disciplinasDaTurma').periodo + `</th> </tr>
                 <tr>
                    <th colspan="2">TURMA: ` + ls.get('disciplinasDaTurma').turma + `</th>
                    <th colspan="5">Iº TRIMESTRE</th>
                    <th colspan="5">IIº TRIMESTRE</th>
                    <th colspan="5">IIIº TRIMESTRE</th>
                    <th rowspan="2">PG</th>
                    <th rowspan="2">MFD</th>
                    <th rowspan="2">O.B.S</th>
                </tr>

                <tr>
                  <td>Nº</td>
                  <td>NOME DO ALUNO</td>

                  <td>MAC</td>
                  <td>NPP</td>
                  <td>NPT</td>
                  <td>MT1</td>
                  <td>F</td>

                  <td>MAC</td>
                  <td>NPP</td>
                  <td>NPT</td>
                  <td>MT1</td>
                  <td>F</td>

                  <td>MAC</td>
                  <td>NPP</td>
                  <td>NPT</td>
                  <td>MT1</td>
                  <td>F</td>

                         </tr>
                         ` + dadosBoletim + `
              </table><br>
              <table class="removeborder">
             <tr class="removeborder">
              <td class="removeborder">Luanda, ` + help.presente_data() + ` </td>
              </tr>
              </table><br>
         <table class="removeborder">
             <tr class="removeborder">
                 <td width="50%" class="removeborder">` + (miniPautaConfiguracoes[1].valor) + `</td>
                 <td width="50%" class="removeborder">` + (miniPautaConfiguracoes[2].valor) + `</td>
             </tr>
             <tr class="removeborder">
                 <td class="removeborder">_____________________________</td>
                 <td class="removeborder">_____________________________</td>
            </tr>
         </table>
             </div>
              </body>
              </html>
`
        let options = { 'format': 'A4',
          'border': {
            'top': '10mm', // default is 0, units: mm, cm, in, px
            'right': '5mm',
            'bottom': '10mm',
            'left': '5mm'
          } }
        this.MiniPautagerarpdf(options)
      } catch (error) {

      } finally {
        this.isLoading = false
      }
    },
    async  MiniPautagerarpdf (options) {
      this.isLoading = true
      try {
        await axios({
          method: 'post',
          url: ls.get('urlReport') + 'writefile',
          data: {
            html: this.html,
            file_name: ls.get('idPessoa'),
            option: options
          }
        }).then(function (response) {
        })
        // Imprimir PDF

        this.isLoading = false
        this.frame()
      } catch (error) {
        this.isLoading = false
      }
    },
    frame () {
      this.isLoading = false
      let link = ls.get('urlReport') + 'readfile/' + ls.get('idPessoa') + '.pdf'
      let frame = `<html> +
      <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
      <body>
      <iframe target="_blank" type="application/pdf" src="` + link + `"></iframe> 
      </body></html>`
      let a = window.open('about:blank', '_blank', '', true)
      a.document.write(frame)
      a.document.close()
    },
    async carregarConfiguracoesReports () {
      try {
        let msg = await axios
          .post('/configuracoes', { empresa: 'report_Pauta' })
          .then(res => res.data)
        if (msg.length > 0) {
          this.configuracoesReport = msg
        }
      } catch (error) {

      }
    }

  }
}
</script>
